import { cn } from "@hireart/component-library";
import PropTypes from "prop-types";

export const DescriptionList = ({ children, className = undefined }) => (
  <dl className={cn("m-0", className)}>{children}</dl>
);

DescriptionList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
